// Helper function to handle desktop app callbacks for both macOS and Windows
export const handleDesktopCallback = (params, isError = false) => {
  const searchParams = new URLSearchParams(window.location.search);
  const isDesktopApp = sessionStorage.getItem('isDesktopApp') === 'true';
  const isWindowsDesktop = sessionStorage.getItem('isWindowsDesktop') === 'true';
  const redirectUri = sessionStorage.getItem('desktopRedirectUri') || searchParams.get('redirect_uri');

  if (!isDesktopApp) {
    return false;
  }

  // Clean up session storage
  sessionStorage.removeItem('isDesktopApp');
  sessionStorage.removeItem('isWindowsDesktop');
  sessionStorage.removeItem('desktopRedirectUri');

  if (isWindowsDesktop) {
    if (redirectUri) {
      // Windows app with custom redirect URI
      const callbackParams = new URLSearchParams(isError ? { error: params } : params);
      window.location.href = `${redirectUri}?${callbackParams.toString()}`;
    } else {
      // Windows app default callback
      const callbackParams = new URLSearchParams(isError ? { error: params } : params);
      window.location.href = `http://localhost:8080/auth/callback?${callbackParams.toString()}`;
    }
  } else {
    // macOS app - use custom scheme
    const callbackParams = new URLSearchParams(isError ? { error: params } : params);
    window.location.href = `projector-app://auth-callback?${callbackParams.toString()}`;
  }

  return true;
};

// Helper to check if running in desktop app context
export const isDesktopAppContext = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const appType = searchParams.get('app');
  return sessionStorage.getItem('isDesktopApp') === 'true'
    || appType === 'desktop'
    || appType === 'windows-desktop';
};

// Helper to check if running in Windows desktop app
export const isWindowsDesktopContext = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const appType = searchParams.get('app');
  const redirectUri = searchParams.get('redirect_uri');
  return sessionStorage.getItem('isWindowsDesktop') === 'true'
    || appType === 'windows-desktop'
    || (appType === 'desktop' && redirectUri);
};

// Helper to store desktop app context
export const storeDesktopContext = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const appType = searchParams.get('app');
  const redirectUri = searchParams.get('redirect_uri');

  if (appType === 'desktop' || appType === 'windows-desktop') {
    sessionStorage.setItem('isDesktopApp', 'true');

    // Store Windows-specific context
    if (appType === 'windows-desktop' || (appType === 'desktop' && redirectUri)) {
      sessionStorage.setItem('isWindowsDesktop', 'true');
    }

    // Store redirect URI if provided
    if (redirectUri) {
      sessionStorage.setItem('desktopRedirectUri', redirectUri);
    }
  }
};

// Helper to get the appropriate callback URL for desktop apps
export const getDesktopCallbackUrl = (params, isError = false) => {
  const isWindowsDesktop = sessionStorage.getItem('isWindowsDesktop') === 'true';
  const redirectUri = sessionStorage.getItem('desktopRedirectUri');

  const callbackParams = new URLSearchParams(isError ? { error: params } : params);

  if (isWindowsDesktop) {
    if (redirectUri) {
      return `${redirectUri}?${callbackParams.toString()}`;
    }
    return `http://localhost:8080/auth/callback?${callbackParams.toString()}`;
  }
  return `projector-app://auth-callback?${callbackParams.toString()}`;
};

// Helper to handle cancellation
export const handleDesktopCancel = () => {
  const isWindowsDesktop = sessionStorage.getItem('isWindowsDesktop') === 'true';
  const redirectUri = sessionStorage.getItem('desktopRedirectUri');

  if (isWindowsDesktop) {
    if (redirectUri) {
      window.location.href = `${redirectUri}?error=cancelled`;
      return;
    }
    window.location.href = 'http://localhost:8080/auth/callback?error=cancelled';
    return;
  }
  window.location.href = 'projector-app://auth-callback?error=cancelled';
};
